<template>
  <ViewCover style="height: 100%">
    <div :style="`${$vuetify.breakpoint.mdAndUp ? 'width: 45%;' : 'right: 0;'} ${$vuetify.breakpoint.lgAndUp ? 'left: 255px;' : 'left: 0;'} position: fixed; top: 65px; bottom: 0; display: flex; flex-direction: row;` ">
      <ScrollNav 
        style="flex-direction: column; justify-content: flex-start" 
        v-if="$vuetify.breakpoint.smAndUp"
        @click:search="() => {
          search_state = !search_state
          if (search_state) {
            $refs.search_field.$el.getElementsByTagName('input')[0].focus()
          } else {
            search_value = ''
          }
        }"
        @click:awaiting="scrollToGroup('delayed')"
        @click:wait_wait_confirmpay="scrollToGroup('wait_confirm')"
        @click:wait_pay="scrollToGroup('wait_pay')"
        @click:cooking="scrollToGroup('cooking')"
        @click:delivery="scrollToGroup('delivering')"
        @click:archive="scrollToGroup('archived')"
        @click:deleted="scrollToGroup('canceled')"
      />
    </div>

      <v-row dense class="fluid" style="height: 100%; padding-left: 50px">
        <v-col :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 360px' : ''">
          <ScrollHandler style="height: calc(100vh - 72px); width: 100%">     
            <template #prepend >
              <div class="search-container" :class="{'search-container-expand': search_state}">
                <TextField 
                  clearable
                  prepend-inner-icon="mdi-text-box-search-outline"
                  @focus="e => $store.dispatch('inputFocus', e)"
                  :label="$t('Поиск заказов')" 
                  class="my-2 ml-2 mr-3"
                  hide-details="auto"
                  ref="search_field"
                  v-model="search_value"
                />
              </div>
              <ScrollNav
                v-if="$vuetify.breakpoint.xs"
                @click:search="() => {
                  search_state = !search_state
                  if (search_state) {
                    $refs.search_field.$el.getElementsByTagName('input')[0].focus()
                  } else {
                    search_value = ''
                  }
                }"
              />
            </template>  
            <!-- <ScrollGroup dark color="error" v-if="orders['NEW']" :counter="orders['NEW'].length" key="1" title="Внимание" icon="mdi-file-document-alert" ref="new">
              <OrderCard v-for="item in orders['NEW']" :order="item" :key="item.id" :orderId="item.id" />
            </ScrollGroup> -->
            <ScrollGroup dark color="purple" v-if="orders['WAIT_CONFIRM']" :counter="orders['WAIT_CONFIRM'].length" key="8" :title="$t('Ожидает подтверждения')" icon="mdi-web-plus" ref="wait_confirm">
              <OrderCard v-for="item in orders['WAIT_CONFIRM']" :order="item" :key="item.id" :orderId="item.id" />
            </ScrollGroup>
            <ScrollGroup dark color="orange" v-if="orders['WAIT_PAY']" :counter="orders['WAIT_PAY'].length" key="7" :title="$t('Ожидает оплаты')" icon="mdi-cash-off" ref="wait_pay">
              <OrderCard v-for="item in orders['WAIT_PAY']" :order="item" :key="item.id" :orderId="item.id" />
            </ScrollGroup>
            <ScrollGroup dark color="primary" v-if="orders['COOKING']" :counter="orders['COOKING'].length" key="3" :title="$t('Готовится')" icon="mdi-chef-hat" ref="cooking">
              <OrderCard v-for="item in orders['COOKING']" :order="item" :key="item.id" :orderId="item.id" />
            </ScrollGroup>
            <ScrollGroup dark color="blue" v-if="orders['DELIVERING']" :counter="orders['DELIVERING'].length" key="4" :title="$t('В пути')" icon="mdi-run-fast" ref="delivering">
              <OrderCard v-for="item in orders['DELIVERING']" :order="item" :key="item.id" :orderId="item.id" />
            </ScrollGroup>
            <ScrollGroup default-folded dark color="grey" v-if="orders['ARCHIVED']" :counter="orders['ARCHIVED'].length"  key="5" :title="$t('В архиве')" icon="mdi-package-down" ref="archived">
              <OrderCard v-for="item in orders['ARCHIVED']" :order="item" :key="item.id" :orderId="item.id" />
            </ScrollGroup>
            <ScrollGroup default-folded dark color="orange" v-if="orders['DELAYED']" :counter="orders['DELAYED'].length" key="2" :title="$t('Отложен')" icon="mdi-clock" ref="delayed">
              <OrderCard v-for="item in orders['DELAYED']" :order="item" :key="item.id" :orderId="item.id" />
            </ScrollGroup>
            <ScrollGroup default-folded dark color="grey-darken-5" v-if="orders['CANCELED']" :counter="orders['CANCELED'].length" key="6" :title="$t('Удален')" icon="mdi-delete-forever" ref="canceled">
              <OrderCard v-for="item in orders['CANCELED']" :order="item" :key="item.id" :orderId="item.id" />
            </ScrollGroup>
            <v-alert v-if="Object.keys(orders).length === 0" :key="-1" color="secondary" icon="mdi-note-alert" border="left" dark>
              <T>Список заказов пуст</T>
            </v-alert>
          </ScrollHandler>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.mdAndUp">
          <!-- <div style="padding-left: 45%; height: 100%" v-if="$vuetify.breakpoint.mdAndUp" class="d-flex"> -->
            <transition name="fade" mode="out-in" class="d-flex flex-column">
              <div v-if="orderId == undefined" class="d-flex justify-center align-center fill-height">
                <div class="text-center">
                  <v-icon x-large style="transform: scale(2)">mdi-file</v-icon>
                  <h3 class="mt-5"><T>Выберите заказ для просмотра</T></h3>

                </div>
              </div>
              <router-view v-else-if="blink"/>
              
            </transition>
          <!-- </div> -->
        </v-col>

      </v-row>
      

      
    <!-- </v-container> -->

    

    <v-bottom-sheet v-if="$vuetify.breakpoint.smAndDown" :value="orderId" scrollable @click:outside="$router.replace('/orders/')" max-width="800">
      <v-card>
        <v-card-actions>
          <v-btn test-tag="tag-234" large icon to="/orders/" replace>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <router-view/>
          <div style="height: 1000px"></div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <!-- <Drawer /> -->
  </ViewCover>
</template>

<script>
import TextField from '../components/common/TextField.vue'
import ViewCover from './ViewCover.vue'
import ScrollHandler from '../components/scroller_handler/index.vue'
import ScrollGroup from '../components/scroller_handler/ScrollGroup.vue'
import OrderCard from '../components/orders/OrderCard.vue'
import ScrollNav from '../components/orders/ScollNav.vue'
// import Drawer from '../components/Drawer.vue'

export default {
  data: () => ({
    search_value: '',
    search_state: false,
    count: 7,
    blink: true
  }),
  components: {
    ViewCover,
    ScrollHandler,
    ScrollGroup,
    OrderCard,
    ScrollNav,
    TextField,
  },
  watch: {
    orderId(){
      this.blink = false
      this.$nextTick(() => {
        this.blink = true
      })
    }
  },
  computed: {
    orderId(){
      return this.$route.params.orderId
    },

    orders(){
      return this.$store.getters.ordersByStatus
    }
  },
  methods:{
    scrollToGroup(group_ref){
      if(this.$refs[group_ref]){
        this.$refs[group_ref].$el.scrollIntoView({ behavior: 'smooth', block: 'start' }) 
      }
    }
  },
  async mounted(){
    await this.$store.dispatch('getOrders')

    if(!this.$store.getters.status_rules){
      await this.$store.dispatch('getStatusRules')
    }
  },
}
</script>

<style scoped>
.search-container {
  overflow: hidden;
  height: 0;
  min-height: 0;
  transition: all .2s ease-in-out;
}

.search-container-expand {
  min-height: 60px;
  height: 60px;
}
</style>